<template>
  <div class="h-full flex flex-col bg-ld-background">
    <AppBar
      :title="_t('user.account_bind')"
      @back="onBack"
    />

    <div class="flex flex-col gap-6 mt-4">
      <div class="flex flex-col gap-3 px-4">
        <div class="text-13px font-semibold text-ld-label-secondary">
          {{ _t('user.bind') }}
        </div>

        <div class="w-full">
          <ListCell
            :title="_t('common.wx')"
            :label="wechatLabel"
          >
            <template #action>
              <TextButton
                v-if="!user.hasBoundWechat"
                :loading="wechatLoading"
                :label="_t('common.bind')"
                @click="onBindWechat"
              ></TextButton>
              <div v-else></div>
            </template>
          </ListCell>

          <ListCell
            :title="_t('auth.email')"
            :label="user.email"
          >
            <template #action>
              <TextButton
                v-if="user.email != null"
                :loading="emailLoading"
                :label="_t('common.unbind')"
                @click="onUnbindEmail"
              ></TextButton>
              <TextButton
                v-else
                :loading="emailLoading"
                :label="_t('common.bind')"
                @click="onBindEmail"
              ></TextButton>
            </template>
          </ListCell>

          <ListCell
            v-if="user.email != null"
            :title="_t('auth.pwd')"
          >
            <template #action>
              <TextButton
                :label="_t('common.update')"
                @click="onChangePwd"
              ></TextButton>
            </template>
          </ListCell>
        </div>
      </div>

      <div class="flex flex-col gap-3 px-4">
        <div class="text-13px font-semibold text-ld-label-secondary">
          {{ _t('user.terminate') }}
        </div>

        <div class="w-full">
          <ListCell
            :title="_t('user.terminate_tip')"
            class="text-red"
            @click="onTerminate"
          >
            <template #action>
              <i class="pi pi-angle-right text-20px text-black"></i>
            </template>
          </ListCell>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import ListCell from '@/components/ListCell/ListCell.vue'
import { useCommonStore } from '@/stores/common-store'
import { getCurrentUser } from '@/api/auth'
import BindEmailForm from './BindEmailForm.vue'
import BindWechat from './BindWechat.vue'
import PasswordChangeForm from './PasswordChangeForm.vue'
import { computed, ref } from 'vue'
import { bindWechat, unbindEmail } from '@/api/user'
import AppBar from '@/mobile/components/AppBar.vue'

const WECHAT_NICKNAME_LIMIT = 10

const store = useCommonStore()
const user = store.user!

const emit = defineEmits<{
  back: []
  terminate: []
}>()

const wechatLabel = computed(() => {
  if (user.hasBoundWechat) {
    const nickname = user.wechatInfo?.nickname ?? ''
    return nickname.length > WECHAT_NICKNAME_LIMIT
      ? `${nickname.slice(0, WECHAT_NICKNAME_LIMIT)}...`
      : nickname
  }
  return ''
})

function onChangePwd() {
  _openDialog(PasswordChangeForm, {
    title: _t('auth.change_pwd'),
    props: {
      email: user.email,
    },
  }).then(newPassword => {
    if (newPassword) {
      _message.success(_t('auth.pwd_changed'))
    }
  })
}

// 微信绑定解绑
const wechatLoading = ref(false)

function onBindWechat() {
  wechatLoading.value = true

  _openDialog(BindWechat, {
    title: _t('auth.scan_bind_wx'),
  })
    .then(code => {
      if (typeof code === 'string') {
        bindWechat(code).then(res => {
          if (res.code === 0) {
            store.patchUser({ hasBoundWechat: true })
            _message.success(_t('auth.wx_bound'))

            getCurrentUser().then(res => {
              store.patchUser({ wechatInfo: res.user.wechatInfo })
            })
            return
          }

          _message.info(res.message)
        })
      }
    })
    .finally(() => {
      wechatLoading.value = false
    })
}

// 邮箱绑定解绑

const emailLoading = ref(false)
function onBindEmail() {
  _openDialog(BindEmailForm, {
    title: _t('auth.bind_email'),
  })
}

function onUnbindEmail() {
  emailLoading.value = true
  unbindEmail()
    .then(res => {
      if (res.code === 0) {
        _message.success(_t('auth.unbind_success'))
        user.email = undefined
        return
      }

      _message.error(res.message)
    })
    .finally(() => {
      emailLoading.value = false
    })
}

function onBack() {
  emit('back')
}

function onTerminate() {
  emit('terminate')
}
</script>
<style scoped></style>
